<template>
  <div class="fd-member-container chevron" @click.prevent.stop="openParty">
    <sym-icon :name="memberIcon" class="item-icon"></sym-icon>
    <span class="fd-member-name-role">
			<span>{{ memberName }}</span>
			<span class="fd-member-role">{{ memberRole }}</span>
		</span>
  </div>
</template>

<script setup lang="ts">
import useEditor, { editorProps, type EditorProps } from "../Editor";
import SymIcon from "../../helpers/SymIcon.vue";
import { defineProps, computed } from "vue";
import {injectEnv} from "../../Environment";

const props = defineProps({
  ...editorProps,
});
const { value } = useEditor(props as EditorProps);
const env = injectEnv();

const memberIcon = computed(() => {
  return value.value.party.icon;
});
const memberName = computed(() => {
  return value.value.party.fileAs;
});
const memberRole = computed(() => {
  return value.value.membership.role;
});

function openParty() {
  env.navigateTo(7 /* party */, value.value.party.id);
}
</script>

<style>
.fd-touch .fd-member-container {
  position: relative;
  padding-right: 24px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.fd-touch .fd-member-name-role {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
}
.fd-touch .fd-member-role {
  font-size: var(--font-size-s);
  color: var(--inactive);
}
</style>
